<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">

<app-sub-header [pageTitle]="'ServicePoints' | translate"></app-sub-header>

<div class="padded-container">

<dx-button
          class="full-width-button"
          text="{{ 'AddNew' | translate }}"
          type="default"
          (onClick)="navigateToNewVisitServicePoint()">
        </dx-button>

        <dx-tab-panel>
          <dxi-item [title]="'Plan' | translate">
            <div *dxTemplate>
              <br />
              <div *ngFor="let plan of usersDioScheduledVisitsResponse?.dioScheduledVisitsList">
                <dx-button 
  class="full-width-button" 
  [text]="plan.servicePointName"
  (onClick)="createNewServedPointByScheduled(plan.id ?? 0)">
</dx-button>
              </div>
            </div>
          </dxi-item>

    <dxi-item [title]="'Visited' | translate">
      <div *dxTemplate>
        <br />
        <div *ngFor="let visit of visitedServicePointsResponse?.dioVisitedServicePointsList">
          <dx-button 
  class="full-width-button" 
  [text]="visit.description"
  [type]="visit.receiverAcceptTime ? 'success' : 'danger'"
  (onClick)="openVisitedServicePoint(visit.id ?? 0)">
</dx-button>

        </div>
      </div>
    </dxi-item>

    <dxi-item [title]="'Unloading' | translate">
      <div *dxTemplate>
        <br />
        <dx-data-grid
  [dataSource]="servedServicePointsForUnloadingResponse?.dioServedServicePointsForUnloading || []"
  [showBorders]="true"
  [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
  (onSelectionChanged)="onSelectionChanged($event)">
  <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
  <dxi-column [caption]="'Description' | translate" dataField="description"></dxi-column>
</dx-data-grid>

<br />
<dx-button
class="full-width-button"
[disabled]="!unloadingButtonEnabled"
type="success"
(onClick)="startUnloading()">
<div *dxTemplate="let data of 'content'">
  <dx-load-indicator
    class="button-indicator"
    [visible]="!unloadingButtonEnabled">
  </dx-load-indicator>
  <span class="dx-button-text">{{ 'Unload' | translate }}</span>
</div>
</dx-button>
      </div>
    </dxi-item>
  </dx-tab-panel>

    <dx-button
          class="full-width-button"
          text="{{ 'Back' | translate }}"
          type="default"
          (onClick)="navigateToVoucher()">
    </dx-button>

</div>
</div>

<dx-popup
  [(visible)]="messageBoxConfirmScheduleUsingVisible"
  [showTitle]="true"
  title="{{ 'VisitRegistration' | translate }}"
  [width]="isMobile ? '100%' : '60%'"
  [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile" [hideOnOutsideClick]="false" [showCloseButton]="true">
    <p>{{ confirmMessage }}</p>

    <div class="popup-footer">
      <dx-button text="{{ 'Create' | translate }}" type="success" (onClick)="confirmScheduleUsing()"></dx-button>
      <dx-button text="{{ 'Cancel' | translate }}" type="danger" (onClick)="cancelScheduleUsing()"></dx-button>
  </div>
</dx-popup>


<dx-popup
  [(visible)]="errorPopupVisible"
  [showTitle]="true"
  title="{{ 'Error' | translate }}"
  [width]="isMobile ? '100%' : '60%'"
  [height]="isMobile ? '100%' : '80%'"
  [class.full-screen-popup]="isMobile"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true">
  <p>{{ errorMessage }}</p>
  <div class="popup-footer">
    <dx-button text="{{ 'Close' | translate }}" type="danger" (onClick)="errorPopupVisible = false"></dx-button>
  </div>
</dx-popup>

